<template>
  <div class="container-label">
    <div class="header d-flex justify-content-end">
      <div class="mr-2">
        <a-button @click.prevent="printLabel">
          <a-icon type="printer" />
          PRINT
        </a-button>
      </div>
      <div class="mr-2">
        <a-button @click.prevent="() => $router.go(-1)">
          CLOSE
        </a-button>
      </div>
    </div>
    <div class="page" v-if="order && user_address && user_data && user_store_data">
      <div class="content px-4 py-4">
        <div class="d-flex justify-content-between mb-4" style="border-bottom: 1px dashed;">
          <div class="text-left mb-2">
            <div class="text-dark font-size-24">
              {{ order.order_id }}
            </div>
            <div class="text-muted">
              {{ $moment(order.order_date).format('DD - MMMM - YYYY HH:mm:ss') }}
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-around mb-4" style="border-bottom: 1px dashed;">
          <div class="text-left mb-2">
            <div class="text-muted mb-1"> Kepada: </div>
            <div> <strong> {{ order.shipping_info.name }} </strong> </div>
            <div> {{ String(order.shipping_info.address).trim() }} </div>
            <div>
              {{
                [
                  order.shipping_info.sub_district,
                  order.shipping_info.district,
                  order.shipping_info.city,
                  order.shipping_info.province,
                ].join(', ')
              }}
            </div>
            <div>{{ order.shipping_info.country }} - {{ order.shipping_info.postal_code }}</div>
            <div>{{ order.shipping_info.phone }}</div>
          </div>

          <div class="text-left mb-2">
            <div class="text-muted mb-1"> Dari: </div>
            <div> <strong> {{ user_store_data.name }} </strong> </div>
            <div class="text-muted"> {{ store_url }} </div>
            <div>
              {{
                [
                  user_address.district,
                  user_address.city,
                  user_address.province,
                ].join(', ')
              }}
            </div>
            <div>{{ user_address.country }}</div>
            <div>{{ user_data.phone }}</div>
          </div>
        </div>

        <div class="d-flex justify-content-around align-items-center mb-4" style="border-bottom: 1px dashed; padding-bottom: .75rem">
          <div>
            <div class="text-muted"> Kurir </div>
            <div> {{ order.shipping_info.logistic.name }} {{ order.shipping_info.logistic.service }} </div>
          </div>
          <div>
            <div class="text-muted mb-2"> Ongkir: </div>
            <div> {{ +order.shipping_info.logistic.cost | currency }} </div>
          </div>
          <div v-if="+order.shipping_info.logistic.insurance_cost">
            <div class="text-muted" > Asuransi: </div>
            <div> {{ +order.shipping_info.logistic.insurance_cost | currency }} </div>
          </div>
          <div v-if="order.shipping_info.logistic.tracking_no">
            <div class="text-muted" > AWB: </div>
            <div> {{ order.shipping_info.logistic.tracking_no }} </div>
          </div>
        </div>

        <div class="d-flex align-items-center">
          <table style="width:100%">
            <tr>
              <th></th>
              <th> Produk </th>
              <th> SKU </th>
              <th>Jumlah</th>
            </tr>
            <tr v-for="(item, index) in order.order_items" :key="index">
              <td> {{ index+1 }} </td>
              <td> {{ item.product_title }} </td>
              <td> {{ item.sku }} </td>
              <td> {{ item.qty }} </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="page-breaker" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'print.label',
  data: () => ({
    order: null,
  }),
  computed: {
    ...mapState(['account', 'storeSetting']),
    ...mapState('user', {
      store_url: state => state.store_url,
    }),
    user_address () {
      return this.account && this.account.profile && this.account.profile?.address_data
    },
    user_data () {
      return this.account && this.account.profile && this.account.profile?.user_data
    },
    user_store_data () {
      return this.storeSetting && this.storeSetting.storeProfile && this.storeSetting.storeProfile.store_data
    },
  },
  methods: {
    fetchOrderDetail () {
      this.$store.dispatch('sales/fetchOrder', this.$route.params.id)
        .then(({ data }) => {
          this.order = data
        })
        .catch(err => {
          console.log(err)
        })
    },
    printLabel () {
      window.print()
    },
  },
  created () {
    this.fetchOrderDetail()
    this.$store.dispatch('storeSetting/GETPROFILE')
    this.$store.dispatch('account/GETUSERPROFILE')
  },
}
</script>

<style lang="scss">

.container-label {
  width: 100%;
  background-color: white;

  .header {
    background-color: #4b7cf3;
    width: 100%;
    padding: .75rem;
  }

  .page {
    text-align: center;
    margin-top: 2rem;

    .content {
      width: 40%;
      border: 1px solid black;
      // margin-top: 1rem;
      margin: auto;
    }

    .page-breaker {
      // position: relative;
      // text-align: center;
      page-break-before: always;
      // margin-bottom: 20px;
    }
  }
}

@media print {
  .container-label {
    .header {
      > div {
        display: none;

      }
    }
    .page {
      .content {
        width: 70%;
      }
    }
  }
}
</style>
